export default function (array) {
  return array.length === 1 ? array[0] : array.join(' ')
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/filters/array2String.js